import { Box, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import './Orders.scss';
import { useTranslation } from 'react-i18next';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Typography from '@mui/material/Typography';
import TabPanel from '../common/ui/TabPanel';
import { ArchivedOrders } from './ArchivedOrders';
import { AllOrders } from './AllOrders';

const Orders = () => {
  const [value, setValue] = useState(0);
  const { t } = useTranslation();
  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <HelmetProvider>
        <Helmet>
          <title>Monkeybook - {t('main_sidebar.orders')}</title>
        </Helmet>
      </HelmetProvider>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Grid container>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab
              label={
                <Typography variant={'h5'} fontWeight={'700'}>
                  {t('orders.orders')}
                </Typography>
              }
            />
            <Tab
              label={
                <Typography variant={'h5'} fontWeight={'700'}>
                  {t('orders.archived')}
                </Typography>
              }
            />
          </Tabs>
        </Grid>
      </Box>

      <TabPanel value={value} index={0}>
        <Paper elevation={2}>
          <AllOrders />
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Paper elevation={2}>
          <Box px={2}>
            <ArchivedOrders />
          </Box>
        </Paper>
      </TabPanel>
    </Box>
  );
};

export default Orders;
